import { Action } from 'redux'

import { File } from '../../lib/interfaces/File.interface'
import { Claim } from '../../lib/interfaces/Claim.interface'
import { Accident } from '../../lib/interfaces/Accident.interface'
import { ClaimArea } from '../../lib/interfaces/ClaimArea.interface'
import { AccidentSummary } from 'src/lib/interfaces/AccidentSummary'
import { AccidentType } from 'src/lib/interfaces/AccidentType.interface'
import { CountSummary } from 'src/lib/interfaces/CountSummary.interface'
import { AccidentStatus } from 'src/lib/interfaces/AccidentStatus.interface'
import { AccidentComment } from '../../lib/interfaces/AccidentComment.interface'
import { AccidentFilterParameters } from 'src/lib/interfaces/AccidentFilterParameters.interface'
import { Point } from 'src/lib/interfaces/point'

export const actionTypes = {
  ACCIDENT_UPSERT: 'ACCIDENT_UPSERT',
  ACCIDENT_UPSERT_SUCCESS: 'ACCIDENT_UPSERT_SUCCESS',
  ACCIDENT_UPSERT_FAILED: 'ACCIDENT_UPSERT_FAILED',

  ACCIDENT_UPSERT_CLAIM: 'ACCIDENT_UPSERT_CLAIM',
  ACCIDENT_UPSERT_CLAIM_SUCCESS: 'ACCIDENT_UPSERT_CLAIM_SUCCESS',
  ACCIDENT_UPSERT_CLAIM_FAILED: 'ACCIDENT_UPSERT_CLAIM_FAILED',

  ACCIDENTS_FETCH: 'ACCIDENTS_FETCH',
  ACCIDENTS_FETCH_SUCCESS: 'ACCIDENTS_FETCH_SUCCESS',
  ACCIDENTS_FETCH_FAILED: 'ACCIDENTS_FETCH_FAILED',

  ACCIDENT_REMOVE: 'ACCIDENT_REMOVE',
  ACCIDENT_REMOVE_SUCCESS: 'ACCIDENT_REMOVE_SUCCESS',
  ACCIDENT_REMOVE_FAILED: 'ACCIDENT_REMOVE_FAILED',

  ACCIDENT_SET_MANAGER_APPROVAL: 'ACCIDENT_SET_MANAGER_APPROVAL',
  ACCIDENT_SET_MANAGER_APPROVAL_SUCCESS: 'ACCIDENT_SET_MANAGER_APPROVAL_SUCCESS',
  ACCIDENT_SET_MANAGER_APPROVAL_FAILED: 'ACCIDENT_SET_MANAGER_APPROVAL_FAILED',

  ACCIDENT_FETCH_FILES: 'ACCIDENT_FETCH_FILES',
  ACCIDENT_FETCH_FILES_SUCCESS: 'ACCIDENT_FETCH_FILES_SUCCESS',
  ACCIDENT_FETCH_FILES_FAILED: 'ACCIDENT_FETCH_FILES_FAILED',

  ACCIDENT_FETCH_OPEN_CLAIMS: 'ACCIDENT_FETCH_OPEN_CLAIMS',
  ACCIDENT_FETCH_OPEN_CLAIMS_SUCCESS: 'ACCIDENT_FETCH_OPEN_CLAIMS_SUCCESS',
  ACCIDENT_FETCH_OPEN_CLAIMS_FAILED: 'ACCIDENT_FETCH_OPEN_CLAIMS_FAILED',

  ACCIDENT_UPLOAD_FILE: 'ACCIDENT_UPLOAD_FILE',
  ACCIDENT_UPLOAD_FILE_SUCCESS: 'ACCIDENT_UPLOAD_FILE_SUCCESS',
  ACCIDENT_UPLOAD_FILE_FAILED: 'ACCIDENT_UPLOAD_FILE_FAILED',

  ACCIDENTS_FETCH_CLAIM: 'ACCIDENTS_FETCH_CLAIM',
  ACCIDENTS_FETCH_CLAIM_SUCCESS: 'ACCIDENTS_FETCH_CLAIM_SUCCESS',
  ACCIDENTS_FETCH_CLAIM_FAILED: 'ACCIDENTS_FETCH_CLAIM_FAILED',

  ACCIDENTS_FETCH_LIST: 'ACCIDENTS_FETCH_LIST',
  ACCIDENTS_FETCH_LIST_SUCCESS: 'ACCIDENTS_FETCH_LIST_SUCCESS',
  ACCIDENTS_FETCH_LIST_FAILED: 'ACCIDENTS_FETCH_LIST_FAILED',

  ACCIDENT_POST_COMMENT: 'ACCIDENT_POST_COMMENT',
  ACCIDENT_POST_COMMENT_SUCCESS: 'ACCIDENT_POST_COMMENT_SUCCESS',
  ACCIDENT_POST_COMMENT_FAILED: 'ACCIDENT_POST_COMMENT_FAILED',

  ACCIDENT_TYPES_FETCH_LIST: 'ACCIDENT_TYPES_FETCH_LIST',
  ACCIDENT_TYPES_FETCH_LIST_SUCCESS: 'ACCIDENT_TYPES_FETCH_LIST_SUCCESS',
  ACCIDENT_TYPES_FETCH_LIST_ERROR: 'ACCIDENT_TYPES_FETCH_LIST_ERROR',

  ACCIDENT_STATUS_FETCH_LIST: 'ACCIDENT_STATUS_FETCH_LIST',
  ACCIDENT_STATUS_FETCH_LIST_SUCCESS: 'ACCIDENT_STATUS_FETCH_LIST_SUCCESS',
  ACCIDENT_STATUS_FETCH_LIST_ERROR: 'ACCIDENT_STATUS_FETCH_LIST_ERROR',

  ACCIDENT_FETCH_CLAIM_AREAS_LIST: 'ACCIDENT_FETCH_CLAIM_AREAS_LIST',
  ACCIDENT_FETCH_CLAIM_AREAS_LIST_SUCCESS: 'ACCIDENT_FETCH_CLAIM_AREAS_LIST_SUCCESS',
  ACCIDENT_FETCH_CLAIM_AREAS_LIST_FAILED: 'ACCIDENT_FETCH_CLAIM_AREAS_LIST_FAILED',

  ACCIDENT_FILTER_PARAMS_RESET: 'ACCIDENT_FILTER_PARAMS_RESET',
  ACCIDENT_FILTER_PARAMS_UPDATED: 'ACCIDENT_FILTER_PARAMS_UPDATED',

  ACCIDENT_HISTOGRAM_FETCH_SUCCESS: 'ACCIDENT_HISTOGRAM_FETCH_SUCCESS',
  ACCIDENTS_SUMMARY_FETCH_SUCCESS: 'ACCIDENTS_SUMMARY_FETCH_SUCCESS',
  ACCIDENTS_PENDING_STATUS_COUNT_FETCH_SUCCESS: 'ACCIDENTS_PENDING_STATUS_COUNT_FETCH_SUCCESS',

  ACCIDENTS_SEARCH_CLAIMS: 'ACCIDENTS_SEARCH_CLAIMS',
  ACCIDENTS_SEARCH_CLAIMS_SUCCESS: 'ACCIDENTS_SEARCH_CLAIMS_SUCCESS',
  ACCIDENTS_SEARCH_CLAIMS_FAILED: 'ACCIDENTS_SEARCH_CLAIMS_FAILED',

  ACCIDENTS_RESET_CLAIMS_SEARCH: 'ACCIDENTS_RESET_CLAIMS_SEARCH',

  ACCIDENTS_REMOVE_CLAIM: 'ACCIDENTS_REMOVE_CLAIM',
  ACCIDENTS_REMOVE_CLAIM_SUCCESS: 'ACCIDENTS_REMOVE_CLAIM_SUCCESS',
  ACCIDENTS_REMOVE_CLAIM_FAILED: 'ACCIDENTS_REMOVE_CLAIM_FAILED',

  ACCIDENTS_SET_CURRENT: 'ACCIDENTS_SET_CURRENT',
  ACCIDENTS_SET_CURRENT_FAILED: 'ACCIDENTS_SET_CURRENT_FAILED',
  ACCIDENTS_SET_CURRENT_SUCCESS: 'ACCIDENTS_SET_CURRENT_SUCCESS'
}

/**
 * Upsert accident
 */
export interface AccidentUpsertAction extends Action {
  payload: {
    accident: Accident
  }
}

export const upsertAccident = (accident: Accident): AccidentUpsertAction => ({
  type: actionTypes.ACCIDENT_UPSERT,
  payload: { accident }
})

// Success
export interface AccidentUpsertSuccessAction extends Action {
  payload: {
    accident: Accident
  }
}

export const upsertAccidentSuccess = (accident: Accident): AccidentUpsertSuccessAction => ({
  type: actionTypes.ACCIDENT_UPSERT_SUCCESS,
  payload: { accident }
})

// Error
export interface AccidentUpsertErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const upsertAccidentError = (errorMessage: string): AccidentUpsertErrorAction => ({
  type: actionTypes.ACCIDENT_UPSERT_FAILED,
  payload: { errorMessage }
})

/**
 * Upsert claim
 */
export interface AccidentUpsertClaimAction extends Action {
  payload: {
    claim: Claim
  }
}

export const upsertClaim = (claim: Claim): AccidentUpsertClaimAction => ({
  type: actionTypes.ACCIDENT_UPSERT_CLAIM,
  payload: { claim }
})

// Success
export interface AccidentUpsertClaimSuccessAction extends Action {
  payload: {
    claim: Claim
  }
}

export const upsertClaimSuccess = (claim: Claim): AccidentUpsertClaimSuccessAction => ({
  type: actionTypes.ACCIDENT_UPSERT_CLAIM_SUCCESS,
  payload: { claim }
})

// Error
export interface AccidentUpsertClaimErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const upsertClaimError = (errorMessage: string): AccidentUpsertClaimErrorAction => ({
  type: actionTypes.ACCIDENT_UPSERT_CLAIM_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch single accident
 */
export interface AccidentsFetchAccidentAction extends Action {
  payload: {
    accidentId: string,
    next?: (error?: any, accident?: Accident) => void
  }
}

export const fetchAccident = (accidentId: string, next?: (error?: any, accident?: Accident) => void): AccidentsFetchAccidentAction => ({
  type: actionTypes.ACCIDENTS_FETCH,
  payload: { next, accidentId }
})

// Success
export interface AccidentsFetchAccidentSuccessAction extends Action {
  payload: {
    accident: Accident
  }
}

export const fetchAccidentSuccess = (accident: Accident): AccidentsFetchAccidentSuccessAction => ({
  type: actionTypes.ACCIDENTS_FETCH_SUCCESS,
  payload: { accident }
})

// Error
export interface AccidentsFetchAccidentErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const fetchAccidentError = (errorMessage: string): AccidentsFetchAccidentErrorAction => ({
  type: actionTypes.ACCIDENTS_FETCH_FAILED,
  payload: { errorMessage }
})

/**
 *
 */
export interface AccidentsRemoveAccidentAction extends Action {
  payload: {
    accidentId: number|string
    next?: (success: boolean) => void
  }
}

export const removeAccident = (accidentId: number|string, next?: (success: boolean) => void):AccidentsRemoveAccidentAction => ({
  type: actionTypes.ACCIDENT_REMOVE,
  payload: { next, accidentId }
})

// Success
export const removeAccidentSuccess = (): Action => ({
  type: actionTypes.ACCIDENT_REMOVE_SUCCESS
})

// Error
export interface AccidentsRemoveAccidentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const removeAccidentError = (errorMessage?: string): AccidentsRemoveAccidentErrorAction => ({
  type: actionTypes.ACCIDENT_REMOVE_FAILED,
  payload: { errorMessage }
})

/**
 * Set manager approval
 */
export interface AccidentSetManagerApprovalAction extends Action {
  payload: {
    next?: () => void
    managerApproval: string
    accidentId: number|string
  }
}

export const setAccidentManagerApproval = (accidentId: number|string, managerApproval: string, next?: () => void): AccidentSetManagerApprovalAction => ({
  type: actionTypes.ACCIDENT_SET_MANAGER_APPROVAL,
  payload: { next, accidentId, managerApproval }
})

// Success
export interface AccidentSetManagerApprovalSuccessAction extends Action {
  payload: {
    accident: Accident
  }
}

export const setAccidentManagerApprovalSuccess = (accident: Accident): AccidentSetManagerApprovalSuccessAction => ({
  type: actionTypes.ACCIDENT_SET_MANAGER_APPROVAL_SUCCESS,
  payload: { accident }
})

// Error
export interface AccidentSetManagerApprovalErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const setAccidentManagerApprovalError = (errorMessage?: string): AccidentSetManagerApprovalErrorAction => ({
  type: actionTypes.ACCIDENT_SET_MANAGER_APPROVAL_FAILED,
  payload: { errorMessage }
})

/**
 * Fecth accident files
 */
export interface AccidentFetchFilesAction extends Action {
  payload: {
    accidentId: number
  }
}

export const fetchAccidentFiles = (accidentId: number): AccidentFetchFilesAction => ({
  type: actionTypes.ACCIDENT_FETCH_FILES,
  payload: { accidentId }
})

// Success
export interface AccidentFetchFilesSuccessAction extends Action {
  payload: {
    files: File[],
    accidentId: number
  }
}

export const fetchAccidentFilesSuccess = (files: File[], accidentId: number): AccidentFetchFilesSuccessAction => ({
  type: actionTypes.ACCIDENT_FETCH_FILES_SUCCESS,
  payload: { files, accidentId }
})

// Error
export interface AccidentFetchFilesErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const fetchAccidentFilesError = (errorMessage: string): AccidentFetchFilesErrorAction => ({
  type: actionTypes.ACCIDENT_FETCH_FILES_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch open claims
 */
export interface AccidentsFetchOpenClaimsAction extends Action {
  payload: {
    next?: () => void
  }
}

export const fetchOpenClaims = (next?: () => void): AccidentsFetchOpenClaimsAction => ({
  type: actionTypes.ACCIDENT_FETCH_OPEN_CLAIMS,
  payload: { next }
})

// Success
export interface AccidentsFetchOpenClaimsSuccessAction extends Action {
  payload: {
    claims: Claim[]
  }
}

export const fetchOpenClaimsSuccess = (claims: Claim[]): AccidentsFetchOpenClaimsSuccessAction => ({
  type: actionTypes.ACCIDENT_FETCH_OPEN_CLAIMS_SUCCESS,
  payload: { claims }
})

// Error
export interface AccidentsFetchOpenClaimsErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const fetchOpenClaimsError = (errorMessage: string): AccidentsFetchOpenClaimsErrorAction => ({
  type: actionTypes.ACCIDENT_FETCH_OPEN_CLAIMS_FAILED,
  payload: { errorMessage }
})

/*
 * Upload accident file
 */
export interface AccidentUploadFileAction extends Action {
 payload: {
   file: any
   accidentId: number | string
 }
}

export const uploadAccidentFile = (accidentId: number|string, file: any): AccidentUploadFileAction => ({
 type: actionTypes.ACCIDENT_UPLOAD_FILE,
 payload: { file, accidentId }
})

// Success
export const uploadAccidentFileSuccess = (): Action => ({
 type: actionTypes.ACCIDENT_UPLOAD_FILE_SUCCESS
})

// Error
export interface AccidentUploadFileErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const uploadAccidentFileError = (errorMessage: string): AccidentUploadFileErrorAction => ({
  type: actionTypes.ACCIDENT_UPLOAD_FILE_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch single claim
 */
export interface AccidentsFetchClaimAction extends Action {
  payload: {
    claimId: number
  }
}

export const fetchClaim = (claimId: number): AccidentsFetchClaimAction => ({
  type: actionTypes.ACCIDENTS_FETCH_CLAIM,
  payload: { claimId }
})

// Success
export interface AccidentsFetchClaimSuccessAction extends Action {
  payload: {
    claim: Claim
  }
}

export const fetchClaimSuccess = (claim: Claim): AccidentsFetchClaimSuccessAction => ({
  type: actionTypes.ACCIDENTS_FETCH_CLAIM_SUCCESS,
  payload: { claim }
})

// Error
export interface AccidentsFetchClaimErrorAction extends Action {
  payload: {
    errorMessage: string
  }
}

export const fetchClaimError = (errorMessage: string): AccidentsFetchClaimErrorAction => ({
  type: actionTypes.ACCIDENTS_FETCH_CLAIM_FAILED,
  payload: { errorMessage }
})

/**
 * Set current accident
 */
export interface AccidentsSetCurrentAction extends Action {
  payload: {
    accident?: Accident
  }
}

export const setCurrentAccident = (accident?: Accident): AccidentsSetCurrentAction => ({
  type: actionTypes.ACCIDENTS_SET_CURRENT,
  payload: { accident }
})

// success
export interface AccidentsSetCurrentSuccessAction extends Action {
  payload: {
    accident: Accident
  }
}

export const setCurrentAccidentSuccess = (accident: Accident): AccidentsSetCurrentSuccessAction => ({
  type: actionTypes.ACCIDENTS_SET_CURRENT_SUCCESS,
  payload: { accident }
})

// error
export interface AccidentsSetCurrentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const setCurrentAccidentError = (errorMessage?: string): AccidentsSetCurrentErrorAction => ({
  type: actionTypes.ACCIDENTS_SET_CURRENT_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch accidents list
 */
export interface AccidentsFetchListAction extends Action {
  payload: {
    next?: () => void,
  }
}

export const fetchAccidentsListDispatchCommand = (next?: () => void): AccidentsFetchListAction => ({
  type: actionTypes.ACCIDENTS_FETCH_LIST,
  payload: { next }
})

// Success
export interface AccidentsFetchListSuccessAction extends Action {
  payload: { accidents }
}

export const fetchAccidentsListSuccessDispatchCommand = (accidents: Accident[]): AccidentsFetchListSuccessAction => ({
  type: actionTypes.ACCIDENTS_FETCH_LIST_SUCCESS,
  payload: { accidents }
})

// Error
export interface AccidentsFetchListErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchAccidentsListErrorDispatchCommand = (errorMessage?: string): AccidentsFetchListErrorAction => ({
  type: actionTypes.ACCIDENTS_FETCH_LIST_FAILED,
  payload: {
    errorMessage
  }
})

/**
 * Post accident comment
 */
export interface AccidentPostCommentAction extends Action {
  payload: {
    comment: string,
    accidentId: string
  }
}

export const postAccidentComment = (accidentId: string, comment: string): AccidentPostCommentAction => ({
  type: actionTypes.ACCIDENT_POST_COMMENT,
  payload: { comment, accidentId }
})

// Success
export interface AccidentPostCommentSuccessAction extends Action {
  payload: {
    accidentId: string
    comment: AccidentComment
  }
}

export const postAccidentCommentSuccess = (accidentId: string, comment: AccidentComment): AccidentPostCommentSuccessAction => ({
  type: actionTypes.ACCIDENT_POST_COMMENT_SUCCESS,
  payload: { comment, accidentId }
})

// Error
export interface AccidentPostCommentErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const postAccidentCommentError = (errorMessage?: string): AccidentPostCommentErrorAction => ({
  type: actionTypes.ACCIDENT_POST_COMMENT_FAILED,
  payload: { errorMessage }
})

/**
 * Fetch Accident Status List
 */

export interface AccidentStatusFetchAction extends Action {
  payload: {
    next?: () => void
  }
}

export const fetchAccidentStatusDispatchCommand = (next?: () => void): AccidentStatusFetchAction => ({
  type: actionTypes.ACCIDENT_STATUS_FETCH_LIST,
  payload: { next }
})

// Success
export interface AccidentStatusFetchActionSuccess extends Action {
  payload: { accidentStatus }
}

export const fetchAccidentStatusSuccessDispatchCommand = (accidentStatus: AccidentStatus[]): AccidentStatusFetchActionSuccess => ({
  type: actionTypes.ACCIDENT_STATUS_FETCH_LIST_SUCCESS,
  payload: {
    accidentStatus
  }
})

// Error
export interface AccidentStatusFetchActionError extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchAccidentStatusErrorDispatchCommand = (errorMessage?: string): AccidentStatusFetchActionError => ({
  type: actionTypes.ACCIDENT_STATUS_FETCH_LIST_ERROR,
  payload: {
    errorMessage
  }
})


/**
 * Fetch accident types
 */
export interface AccidentTypesFetchAction extends Action {
  payload: {
    next?: () => void,
  }
}

export const fetchAccidentTypesDispatchCommand = (next?: () => void): AccidentTypesFetchAction => ({
  type: actionTypes.ACCIDENT_TYPES_FETCH_LIST,
  payload: { next }
})

// Success
export interface AccidentTypesFetchActionSuccess extends Action {
  payload: { accidentTypes }
}

export const fetchAccidentTypesSuccessDispatchCommand = (accidentTypes?: AccidentType[]): AccidentTypesFetchActionSuccess => ({
  type: actionTypes.ACCIDENT_TYPES_FETCH_LIST_SUCCESS,
  payload: {
    accidentTypes
  }
})

// Error
export interface AccidentTypesFetchActionError extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchAccidentTypesErrorDispatchCommand = (errorMessage?: string): AccidentTypesFetchActionError => ({
  type: actionTypes.ACCIDENT_TYPES_FETCH_LIST_ERROR,
  payload: {
    errorMessage
  }
})


/**
 * Fetch claim areas
 */
export interface AccidentsFetchClaimAreasAction extends Action {
  payload: {
    next?: () => void,
  }
}

export const fetchClaimAreas = (next?: () => void): AccidentsFetchClaimAreasAction => ({
  type: actionTypes.ACCIDENT_FETCH_CLAIM_AREAS_LIST,
  payload: { next }
})

// Success
export interface AccidentsFetchClaimAreasSuccessAction extends Action {
  payload: {
    claimAreas: ClaimArea[]
  }
}

export const fetchClaimAreasSuccess = (claimAreas: ClaimArea[]): AccidentsFetchClaimAreasSuccessAction => ({
  type: actionTypes.ACCIDENT_FETCH_CLAIM_AREAS_LIST_SUCCESS,
  payload: { claimAreas }
})

// Error
export interface AccidentsFetchClaimAreasErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const fetchClaimAreasError = (errorMessage?: string): AccidentsFetchClaimAreasErrorAction => ({
  type: actionTypes.ACCIDENT_FETCH_CLAIM_AREAS_LIST_FAILED,
  payload: {
    errorMessage
  }
})

/**
 * Search claim
 */
export interface AccidentsSearchClaimsAction extends Action {
  payload: {
    params: any
  }
}

export const searchClaims = (params: any): AccidentsSearchClaimsAction => ({
  type: actionTypes.ACCIDENTS_SEARCH_CLAIMS,
  payload: { params }
})

// Success
export interface AccidentsSearchClaimsSuccessAction extends Action {
  payload: {
    claims: Claim[]
  }
}

export const searchClaimsSuccess = (claims: Claim[]): AccidentsSearchClaimsSuccessAction => ({
  type: actionTypes.ACCIDENTS_SEARCH_CLAIMS_SUCCESS,
  payload: { claims }
})

// Error
export interface AccidentsSearchClaimsErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const searchClaimsError = (errorMessage?: string): AccidentsSearchClaimsErrorAction => ({
  type: actionTypes.ACCIDENTS_SEARCH_CLAIMS_FAILED,
  payload: { errorMessage }
})

/**
 * Reset claims search
 */
export const resetClaimsSearch = (): Action => ({
  type: actionTypes.ACCIDENTS_RESET_CLAIMS_SEARCH
})

/**
 * Reset filter
 */
export interface AccidentFilterParamsResetAction extends Action {
  payload: {
    filterParams?: AccidentFilterParameters
  }
}

export const accidentFilterParamsResetDispatchCommand = (filterParams?: AccidentFilterParameters): AccidentFilterParamsResetAction => ({
  type: actionTypes.ACCIDENT_FILTER_PARAMS_RESET,
  payload: { filterParams }
})

/**
 * Update filter
 */
export interface AccidentFilterChangedAction extends Action {
  payload: {
    next?: () => void
    params: AccidentFilterParameters
  }
}

export const updateAccidentFilterParamsDispatchCommand = (filterParams: AccidentFilterParameters, next?: () => void): AccidentFilterChangedAction => ({
  type: actionTypes.ACCIDENT_FILTER_PARAMS_UPDATED,
  payload: {
    next,
    params: filterParams
  }
})

/**
 * Update accident histogram
 */
export interface AccidentHistogramFetchSucceeded extends Action {
  payload: {
    data: Point[]
  }
}

export const accidentHistogramFetchSucceededDispatchCommand = (data: Point[]): AccidentHistogramFetchSucceeded => ({
  type: actionTypes.ACCIDENT_HISTOGRAM_FETCH_SUCCESS,
  payload: {
    data
  }
})

/**
 * Update accident summary
 */
export interface AccidentSummaryFetchSucceeded extends Action {
  payload: {
    data: AccidentSummary
  }
}

export const accidentSummaryFetchSucceededDispatchCommand = (data: AccidentSummary): AccidentSummaryFetchSucceeded => ({
  type: actionTypes.ACCIDENTS_SUMMARY_FETCH_SUCCESS,
  payload: {
    data
  }
})

/**
 * Update accident `pending` status count
 */
export interface AccidentPendingStatusCountFetchSucceeded extends Action {
  payload: {
    data: CountSummary
  }
}

export const accidentPendingStatusCountFetchSucceeded = (data: CountSummary): AccidentPendingStatusCountFetchSucceeded => ({
  type: actionTypes.ACCIDENTS_PENDING_STATUS_COUNT_FETCH_SUCCESS,
  payload: {
    data
  }
})

/**
 * Remove claim
*/
export interface AccidentsRemoveClaimAction extends Action {
  payload: {
    claimId: number|string
    next?: () => void
  }
}

export const removeClaim = (claimId: number|string, next?: () => void): AccidentsRemoveClaimAction => ({
  type: actionTypes.ACCIDENTS_REMOVE_CLAIM,
  payload: { next, claimId }
})

// Success
export const removeClaimSuccess = (): Action => ({
  type: actionTypes.ACCIDENTS_REMOVE_CLAIM_SUCCESS
})

// Error
export interface AccidentsRemoveClaimErrorAction extends Action {
  payload: {
    errorMessage?: string
  }
}

export const removeClaimError = (errorMessage?: string): AccidentsRemoveClaimErrorAction => ({
  type: actionTypes.ACCIDENTS_REMOVE_CLAIM_FAILED,
  payload: { errorMessage }
})

export type ActionTypes = AccidentsFetchListAction | AccidentsFetchListSuccessAction | AccidentsFetchListErrorAction



// WEBPACK FOOTER //
// ./src/store/accidents/actions.ts